import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { FullScreenLoader } from "@/components/Spinner";

import Login from "@/pages/Login";
import WorkerLayout from "@/components/layout/WorkerLayout";
import AdminLayout from "@/components/layout/AdminLayout";

import WorkerMap from "@/pages/worker/WorkerMap";
import WorkerToday from "@/pages/worker/WorkerToday";

import Dashboard from "@/pages/admin/Dashboard";
import LiveMap from "@/pages/admin/LiveMap";
import StatsDetail from "@/pages/admin/StatsDetail";
import DailyReport from "@/pages/admin/DailyReport";
import HistoryPage from "@/pages/admin/History";
import Workers from "@/pages/admin/Workers";
import MapEditor from "@/pages/admin/MapEditor";
import SettingsPage from "@/pages/admin/Settings";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin/dashboard" : "/worker/map"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              element={
                <ProtectedRoute role="worker">
                  <WorkerLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/worker/map" element={<WorkerMap />} />
              <Route path="/worker/today" element={<WorkerToday />} />
            </Route>

            <Route
              element={
                <ProtectedRoute role="admin">
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/map" element={<LiveMap />} />
              <Route path="/admin/stats/:category" element={<StatsDetail />} />
              <Route path="/admin/report" element={<DailyReport />} />
              <Route path="/admin/history" element={<HistoryPage />} />
              <Route path="/admin/workers" element={<Workers />} />
              <Route path="/admin/map-editor" element={<MapEditor />} />
              <Route path="/admin/settings" element={<SettingsPage />} />
            </Route>

            <Route path="/" element={<RootRedirect />} />
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
